import { StatAccent } from "./metrics";

/** Default height for Recharts responsive wrappers (px). */
export const CHART_CONTAINER_HEIGHT_PX = 280;

/** Category / series colors (charts, ranked lists). */
export const chartColorSequence = [
  StatAccent.coral,
  StatAccent.blue,
  StatAccent.green,
  StatAccent.amber,
  "#8B5CF6",
  "#EC4899",
] as const;

export const lineChartPrimaryStroke = StatAccent.coral;
